import apiClient from './apiClient.js';

export const resumeEvent = async (event_id) => {
    const resume_url = '/event/resume';

    try {
        const response = await apiClient.post(resume_url, {
            event_id: event_id,
        });
        return response.data.response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
